/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type Overview from '@jira/spa-apps__admin-pages-performance-overview/src/OverviewWithErrorBoundary.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyOverview: LazyComponent<() => React.JSX.Element> = lazyForPaint<typeof Overview>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-system-performance-overview", jiraSpaEntry: "async-system-performance-overview" */ '@jira/spa-apps__admin-pages-performance-overview/src/OverviewWithErrorBoundary.tsx'
			),
		),
);

const AsyncOverview = (): React.JSX.Element => (
	<LazyPage Page={LazyOverview} pageId="system-performance-overview" shouldShowSpinner />
);

export default AsyncOverview;
